
import PeerGroupForm from '@/components/Settings/PeerGroup/Form';

export default {
  components: {
    PeerGroupForm
  }
};
